import { render } from "./site-footer.vue?vue&type=template&id=3211183c"
import script from "./site-footer.vue?vue&type=script&lang=js"
export * from "./site-footer.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__